// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".steps-background[data-v-bd3fa8a8]{background-color:#f6f6f6}", ""]);
// Exports
module.exports = exports;
